import IconChevronDownSmall from '@picsart/icons/IconChevronDownSmall';
import cls from 'classnames';

import useStyles from './footerTitleStyles';
import { FooterTitleProps } from './types';

export function FooterTitle({ isExpandable, children, isExpanded, onClick }: FooterTitleProps) {
  const classes = useStyles({ isExpandable });

  const content = <h2 className={classes.title}>{children}</h2>;

  return isExpandable ? (
    <div className={classes.container} onClick={onClick}>
      {content}
      <IconChevronDownSmall className={cls(classes.icon, isExpanded && classes.iconReversed)} />
    </div>
  ) : (
    content
  );
}
